import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';
import { SyncStatus } from '@/components/common/SyncStatus';

export function Header() {
  const { t } = useTranslation();
  const location = useLocation();
  const isEditor = location.pathname.startsWith('/editor');
  const isHome = location.pathname === '/';
  const navItems = [
    { to: '/editor', label: t('nav.editor') },
    { to: '/settings', label: t('nav.settings') },
    { to: '/auth', label: t('nav.auth') },
  ];

  return (
    <header className="border-b bg-background/95 backdrop-blur">
      <div
        className={cn(
          'flex h-14 items-center justify-between gap-4',
          isEditor && 'w-full px-4',
          isHome && 'mx-auto w-full max-w-6xl px-4',
          !isEditor && !isHome && 'container',
        )}
      >
        <Link to="/" className="text-lg font-semibold">
          {t('home.title')}
        </Link>
        <div className="flex items-center gap-4 text-sm">
          <SyncStatus />
          <nav className="flex gap-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'text-muted-foreground transition-colors hover:text-foreground',
                    isActive && 'font-medium text-foreground',
                  )
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}
